import React from "react";
import PropTypes from "prop-types";

import Str from "shared/components/Str";
import Strf from "shared/components/Strf";
import { PRODUCT_SUBTYPES } from "shared/payment/constants";

import "./LegalText.scss";

const LegalText = ({ productSubtype, isPayPalScreen }) => {
	let component;

	const ctaText = isPayPalScreen ? "Continue to PayPal" : "Confirm Purchase";
	const terms = (
		<a
			target="_blank"
			rel="noopener noreferrer"
			href="https://okcupid.com/legal/terms"
		>
			<Str>Terms</Str>
		</a>
	);

	switch (productSubtype) {
		case PRODUCT_SUBTYPES.ALIST:
		case PRODUCT_SUBTYPES.ALISTPREMIUM:
		case PRODUCT_SUBTYPES.INCOGNITO:
			component = (
				<React.Fragment>
					<Strf vars={{ ctaText, terms }}>
						By tapping $ctaText or Pay with Google Play,
						we will charge your card, your subscription will automatically
						renew for the same package length at the same price until you cancel
						in Account Settings, and you agree to our $terms.
					</Strf>
				</React.Fragment>
			);
			break;
		case PRODUCT_SUBTYPES.BOOST:
			component = (
				<React.Fragment>
					<Strf vars={{ ctaText, terms }}>
						Your first boost starts immediately. By tapping $ctaText
						or Pay with Google Play you agree to our $terms.
					</Strf>
				</React.Fragment>
			);
			break;
		case PRODUCT_SUBTYPES.STACK_PASS:
		case PRODUCT_SUBTYPES.READ_RECEIPT:
			component = (
				<React.Fragment>
					<Strf vars={{ ctaText, terms }}>
							By tapping $ctaText or Pay with Google Play you agree to our $terms.
					</Strf>
				</React.Fragment>
			);
			break;
		default:
			component = "";
	}

	return (
		<div className="payment-purchase-legal-text">
			{component}
		</div>
	);
};

LegalText.propTypes = {
	productSubtype: PropTypes.oneOf(Object.values(PRODUCT_SUBTYPES)).isRequired,
	isPayPalScreen: PropTypes.bool,
};

LegalText.defaultProps = {
	isPayPalScreen: false,
};

export default LegalText;



// WEBPACK FOOTER //
// ./src/apps/payment/components/LegalText/LegalText.jsx